import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'agePipe'
})
export class AgePipe implements PipeTransform {
    public transform(value: number, ...args: any[]): any {
        if (!value) {
            return '';
        }
        if (value > 365) {
            return `${(value / 365.25).toFixed()} years`;
        }

        if (value > 31) {
            return `${(value / 30.4167).toFixed()} months`;
        }

        return `${value} days`;
    }

}
